import React, { useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import "./Navbar.css";
import { useAuth } from "./items/AuthProvider";

const Sidebar = ({ name }) => {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const getLastparam = () => {
    const url = window.location.href;
    const parts = url.split("/");
    return parts[parts.length - 1];
  };
  const company = getLastparam();

  const hideMenu = () => {
    setMenuOpen(false);
  };

  console.log("usersidebard ", user);

  return (
    <nav className="top-nav">
      {/* Top Navigation Bar */}
      <div className="flex items-center pl-5 pr-5 w-full">
        {/* Left side: Menu and Title */}
        <div className="flex items-center flex-grow">
          <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="title ml-4">Points:{user?.points}</div>
        </div>

        {/* Right side: Shopping Cart Icon */}
        {/* <div className="flex items-center">
          <ShoppingCartOutlinedIcon style={{ fontSize: "40px" }} />
        </div> */}
      </div>
      {/* Sliding Sidebar */}
      {user ? (
        <ul className={menuOpen ? "sidebar open" : "sidebar"}>
          {/* <li>
            <NavLink to="/" onClick={hideMenu}>
              Home
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/Locations" onClick={hideMenu}>
              Locations
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/giftcard" onClick={hideMenu}>
              Gift Card
            </NavLink>
          </li> */}
          {user?.add_to_cart?.machine && (
            <li>
              <NavLink to="/pendingorder" onClick={hideMenu}>
                Pending Order
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to="/Orders" onClick={hideMenu}>
              Order History
            </NavLink>
          </li>
          <li>
            <NavLink to="QRcode" onClick={hideMenu}>
              My QR Code
            </NavLink>
          </li>
          <li>
            <NavLink to="/logout" onClick={hideMenu}>
              Logout
            </NavLink>
          </li>
        </ul>
      ) : (
        <ul className={menuOpen ? "sidebar open" : "sidebar"}>
          <li>
            <NavLink to={`/login/${company}`} onClick={hideMenu}>
              Login In
            </NavLink>
          </li>
        </ul>
      )}
    </nav>
  );
};
export default Sidebar;
